import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import MacroContainer from '../../_layout/Macro/MacroContainer'
import defaultProps from '../../../utils/propTypes/defaultProps'
import { BackgroundVariant, ComponentVariant } from '../../../utils/defaultTypes'
import CtaModule from '../../molecules/CtaModule/CtaModule'
import { HeadlineTag } from '../../../utils/constants/typography'

const M006L = ({ headline, text, link, icon, settings }) => {
  const backgroundColorClasses = classNames({
    'bg-faf8eb': settings?.backgroundVariant === BackgroundVariant.SAND,
    'bg-e8f4f2': settings?.backgroundVariant === BackgroundVariant.PASTEL_BLUE,
    'bg-ebfae8': settings?.backgroundVariant === BackgroundVariant.PASTEL_GREEN,
  })

  return (
    <MacroContainer dataTrackingName="M006L">
      <CtaModule
        headline={headline}
        text={text}
        link={link}
        icon={icon}
        settings={{ headlineSize: HeadlineTag.H3 }}
        className={`py-48 px-16 600:px-24 1280:py-80 840:grid 840:grid-cols-8 840:gap-24 1000:gap-32 ${backgroundColorClasses}`}
        innerClassName="840:col-start-2 840:col-end-8"
      />
    </MacroContainer>
  )
}

M006L.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
    tag: PropTypes.string,
    placeholder: PropTypes.shape({
      text: PropTypes.string,
    }),
  }),
  text: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self']),
  }),
  settings: PropTypes.shape({
    variant: PropTypes.oneOf([ComponentVariant.MEDIUM, ComponentVariant.LARGE]),
    backgroundVariant: PropTypes.oneOf([
      BackgroundVariant.SAND,
      BackgroundVariant.PASTEL_BLUE,
      BackgroundVariant.PASTEL_GREEN,
    ]),
  }),
}

M006L.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  icon: defaultProps.ICON,
  text: defaultProps.TEXT,
  link: {
    title: defaultProps.TITLE,
    url: defaultProps.URL,
    target: '_self',
  },
  settings: {
    variant: ComponentVariant.LARGE,
    backgroundVariant: BackgroundVariant.SAND,
  },
}

export default M006L
